// 소모 칼로리 = MET × 3.5 × 체중(kg) ÷ 200 × 시간(분)
const MET = 3.5;
// 회원 체중 정보가 없으면 이 값으로 계산한다.
export const DEFAULT_WEIGHT_KG = 70;

export default function calcCalories(
  weightKg: number | null | undefined,
  minutes: number,
) {
  const weight = weightKg ?? DEFAULT_WEIGHT_KG;
  return Math.round(((MET * 3.5 * weight) / 200) * minutes);
}
